import React from "react";
import { toastr } from "react-redux-toastr";
import { Column } from "../lib_react_adminlte/componentes/Table.jsx";
import LabeledInput from "../lib_react_adminlte/componentes/LabeledInput.jsx";
import Cadastro from "./Cadastro.jsx";
import { Table } from "../lib_react_adminlte/componentes/Table.jsx";
import Api from "../utils/Api.jsx";
import RecordSelect from "../lib_react_adminlte/componentes/RecordSelect.jsx";
import ContentWrapper from "../lib_react_adminlte/componentes/ContentWrapper.jsx";
import usuarioReducer from "../lib_react_adminlte/main/usuarioReducer.js";
import { connect } from "react-redux";
import Box from "../lib_react_adminlte/componentes/Box.jsx";
import { getNomeMes } from "../utils/utils";
import GenericUtils from "../lib_react_frontend/utils/GenericUtils.jsx";
import Button from "../lib_react_adminlte/componentes/Button.jsx";
import InputGroup from "../lib_react_adminlte/componentes/InputGroup.jsx";
import Checkbox from "../lib_react_adminlte/componentes/Checkbox.jsx";



/**
 * Componente de cadastro de funcionário.
 */
class Fechamento extends React.Component {

  constructor() {
    super();
    this.boxRefs = {};
  }
  state = {
    empresa: {},
    pesquisa: "",
    linhaDestacada: -1,
    fechamentos: [
      {
        ano: "",
        meses: [
          {
            mes: "",
            link_download_direto: "",
            nome_arquivo: "",
            hora_recebimento: "",
          },
        ],
      },
    ],
    registros: [],
    registro: this.getRegistroLimpo(),
    checkedItems: [],
    currentOpenBoxId: null,
    isLoading: false,
    isDisabled: false,
  };


  async renderFechamento(cnpj) {
    const ret = await Api.getDadosEmpresaFechamento(cnpj);
    if (!ret.status) {
      console.log(ret);

      GenericUtils.setElementoCarregando(this, false);
      return;
    }
    GenericUtils.setElementoCarregando(this, false);
    this.setState({
      empresa: ret.dados.empresa,
      fechamentos: ret.dados.fechamentos,
    });
  }
  handleSelectAllCheckboxes(year) {
    const updatedCheckedItems = this.state.checkedItems.slice(); // Crie uma cópia dos checkboxes selecionados

    // Itere sobre os checkboxes dos meses do ano especificado e marque-os
    this.state.fechamentos.forEach((fechamento) => {
      if (fechamento.ano === year) {
        fechamento.meses.forEach((mes) => {
          if (!updatedCheckedItems.includes(mes.link_download_direto)) {
            updatedCheckedItems.push(mes.link_download_direto);
          }
        });
      }
    });

    this.setState({ checkedItems: updatedCheckedItems }); // Atualize o estado com os checkboxes selecionados
  }
  renderMeses(dados) {
    let mesesOrdenados = dados.sort((a, b) => a.mes - b.mes);

    return mesesOrdenados.map((x) => {
      // Verifica se o link começa com "http://" e substitui por "https://"
      const link = x.link_download_direto.startsWith("http://")
        ? x.link_download_direto.replace("http://", "https://")
        : x.link_download_direto;

      // Define se o item está marcado
      const isChecked = this.state.checkedItems.includes(x.link_download_direto);

      return (
        <div
          className="campoDownload m-0 box-item"
          style={{
            lineHeight: "2",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => this.handleCheckboxChange(x.link_download_direto)}
        >
          <Checkbox
            checked={isChecked}
            onChange={(e) => e.stopPropagation()}
          />
          <span className="fs-20 wx-100 fl block">{getNomeMes(x.mes)}</span>
          <a
            target="_blank"
            href={link}
            id="linkDownload"
            onClick={(e) => e.stopPropagation()}
          >
            {x.nome_arquivo}
          </a>
          <span style={{ float: "right", marginRight: "4px" }}>
            {" "}
            Data Envio: {x.hora_recebimento}
          </span>
        </div>
      );
    });
  }


  handleCheckboxChange = (link_download_direto) => {
    this.setState((prevState) => {
      const { checkedItems } = prevState;
      const index = checkedItems.indexOf(link_download_direto);

      if (index === -1) {
        // Se o link não estiver no array, adicione-o
        checkedItems.push(link_download_direto);
      } else {
        // Se o link estiver no array, remova-o
        checkedItems.splice(index, 1);
      }

      return { checkedItems }; // Atualize o estado com os links de download selecionados
    });
  };

  handleBoxToggle = (id) => {
    const { currentOpenBoxId, isDisabled } = this.state;
    // console.log('Current id:', currentOpenBoxId);

    if (isDisabled) {
      // Se o clique está desativado, ignore o evento
      return;
    }

    this.setState({ isDisabled: true }); // Desativa os cliques

    setTimeout(() => {
      this.setState({ isDisabled: false }); 
    }, 510); 


    if (currentOpenBoxId && currentOpenBoxId !== id) {
      const previousBoxRef = this.boxRefs[currentOpenBoxId];

      if (previousBoxRef && previousBoxRef.fecharBox) {
        previousBoxRef.fecharBox();
      }
    } else{

    }
    this.setState({
      currentOpenBoxId: currentOpenBoxId === id ? currentOpenBoxId : id,
      checkedItems: []
    }, () => {
      // console.log('Current box id apos o set:', this.state.currentOpenBoxId);

    });


  };


  renderBoxFechamentos() {
    return this.state.fechamentos.map((x) => {
      return (
        <Box
          key={x.ano}
          clickDisabled={this.state.isDisabled}
          ref={(el) => (this.boxRefs[x.ano] = el)}
          collapsible
          title={x.ano}
          id={x.ano}
          onToggle={this.handleBoxToggle}
          className="m-0"
          onSelectAllCheckboxes={() => this.handleSelectAllCheckboxes(x.ano)}
        >
          {this.renderMeses(x.meses)}
        </Box>
      );
    });
  }


  async componentDidMount() {
    try {
      GenericUtils.setElementoCarregando(this, true);

      const ret = await Api.getEmpresaUsuario(this.props.redux.usuario, "");
      if (!ret.status) {
        console.log(ret);

        GenericUtils.setElementoCarregando(this, false);
        return toastr.error("Erro!", ret.erro.error_message);
      }

      this.setState({ registros: ret.dados });

      GenericUtils.setElementoCarregando(this, false);
      return ret;
    } catch (error) {
      console.error(error);
    }
  }
  async getRegistros(usuario) {
    const ret = await Api.getEmpresaUsuario(usuario, "");
    if (!ret.status) {
      console.log(ret);

      return toastr.error("Erro!", ret.erro.error_message);
    }
    this.setState({ registros: ret.dados });

    return ret;
  }
  renderColunas() {
    return [<Column key={1} field="razao_social" header="Empresa" />];
  }
  getRegistroLimpo() {
    return {
      id: "",
      razao_social: "",
      doc_federal: "",
    };
  }
  limparRegistro() {
    this.setState({
      registro: this.getRegistroLimpo(),
    });
  }
  getMsgExcluir() {
    return (
      "Tem certeza que deseja excluir " +
      this.state.registro.razao_social +
      " ?"
    );
  }
  getRegistro() {
    const { id, razao_social, doc_federal } = this.state.registro;
    return { id, razao_social, doc_federal };
  }
  setRegistro(item) {
    this.setState({
      registro: {
        id: item.id,
        razao_social: item.razao_social,
        doc_federal: item.doc_federal,
      },
    });
  }
  renderColunas() {
    return [<Column key={1} field="razao_social" header="Nome do Usuario" />];
  }

  handleTableAction(actionName, item, index) {
    if (actionName === "fechamento") {

      Object.values(this.boxRefs).forEach((boxRef) => {
        if (boxRef && typeof boxRef.fecharBox === "function") {
          boxRef.fecharBox();
        }
      });
      this.boxRefs = {};
      this.setState({ currentOpenBoxId: null,
        isDisabled: true
       });

    setTimeout(() => {
      this.setState({ isDisabled: false });
    }, 500);

      
      GenericUtils.setElementoCarregando(this, true);

      const copy = this.state.registros.map((record) => {
        return { ...record, linhaSelecionada: "N" };
      });

      copy[index].linhaSelecionada = "S";

      this.setState({ registros: copy });
      GenericUtils.setElementoCarregando(this, true);
      this.renderFechamento(item.doc_federal);
    }
  }

  handleDownloadBtn = async () => {

    const links = this.state.checkedItems;
    let empresa = this.state.empresa.razao_social


    if (links.length === 0) {
      toastr.warning("Nenhum item selecionado para download.");
      return;
    }

    empresa = empresa.replace(/\s+/g, '_');
    this.setState({ isLoading: true });

    const adjustedUrls = links.map(url => {
      const driveMatch = url.match(/drive\.google\.com\/file\/d\/([^/]+)/);
      return driveMatch
        ? `https://drive.google.com/uc?id=${driveMatch[1]}&export=download`
        : url;
    });

    try {
      const response = await Api.getDownloadFechamento(adjustedUrls);

      const downloadUrl = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `FECHAMENTO_${empresa}.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      toastr.warning('Erro ao baixar o arquivo:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  }


  render() {
    const actions = [
      {
        className: "mr-5 btn-blue btnMenor10",
        icone: "fa-file",
        id: "fechamento",
        tipo: Table.ACAO_TABELA,
      },
    ];
    return (

      <div>
        <div className="h-100" style={{}}>
          <ContentWrapper>
            <div
              style={{
                height: window.innerHeight - 155,
                display: "flex",
                marginTop: "40px",
                flexDirection: "column",
              }}
            >
              <div
                className="filtro"
                style={{
                  height: "20%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px"
                }}
              >
                <div style={{ width: "50%" }}>
                  <InputGroup
                    placeholder="Digite seu filtro"
                    buttonIcon="fa-check"
                    buttonLabel="Pesquisar"
                    value={this.state.pesquisa}
                    inputRef={(e) => (this.input = e)}
                    onChange={(e) => this.setState({ pesquisa: e.target.value })}
                    onKeyEnter={async (e) => {
                      GenericUtils.setElementoCarregando(this, true);
                      const ret = await Api.getEmpresaUsuario(
                        this.props.redux.usuario,
                        this.state.pesquisa
                      );
                      if (!ret.status) {
                        console.log(ret);
                        GenericUtils.setElementoCarregando(this, false);
                        return toastr.error("Erro!", ret.erro.error_message);
                      }
                      this.setState({ registros: ret.dados });
                      GenericUtils.setElementoCarregando(this, false);
                      return ret;
                    }}
                    onClick={async () => {
                      GenericUtils.setElementoCarregando(this, true);
                      const ret = await Api.getEmpresaUsuario(
                        this.props.redux.usuario,
                        this.state.pesquisa
                      );
                      if (!ret.status) {
                        console.log(ret);
                        GenericUtils.setElementoCarregando(this, false);
                        return toastr.error("Erro!", ret.erro.error_message);
                      }
                      this.setState({ registros: ret.dados });
                      GenericUtils.setElementoCarregando(this, false);
                      return ret;
                    }}
                  />
                </div>
                <div style={{ position: "relative" }}>
                  <Button
                    label={this.state.isLoading ? "Baixando..." : "Download"}
                    className="btn-blue"
                    disabled={this.state.isLoading} // Desativa o botão durante o loading
                    onClick={this.handleDownloadBtn}
                  />
                  {this.state.isLoading && (
                    <div
                      className="loading-spinner"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <i className="fa fa-spinner fa-spin"></i>
                    </div>
                  )}
                </div>
              </div>
              <div
                className="box"
                style={{
                  height: window.innerHeight - 150,
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "white",
                  alignItems: "flex-start",
                }}
              >
                <div
                  className="c2"
                  style={{
                    width: "50%",
                    boxSizing: "border-box",
                    height: window.innerHeight - 140,
                    overflow: "auto",
                  }}
                >
                  <Table
                    actions={actions}
                    espacamento={false}
                    borda={false}
                    onActionClick={(id, item, index) =>
                      this.handleTableAction(id, item, index)
                    }
                    className="tabelaMed"
                    style={{ width: "100%" }}
                    hideActions={true}
                    maxHeight={window.innerHeight - 220}
                    data={this.state.registros}
                    onSelectItem={(item, index) => {
                      this.handleTableAction("fechamento", item, index);
                    }}
                  >
                    <Column
                      style={{}}
                      key={1}
                      field="razao_social"
                      header="Nome Empresa"
                    />
                  </Table>
                </div>
                <div
                  className="c1"
                  style={{
                    width: "50%",
                    height: window.innerHeight - 150,
                    overflow: "auto"
                  }}
                >
                  {this.renderBoxFechamentos()}
                </div>
              </div>
            </div>
          </ContentWrapper>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    usuario: state.usuario,
    redux: state,
    filiais: state.filiais,
    mudarSenha: state.mudarSenha,
    dados_empresa: state.dados_empresa,
    socket: state.socket,
  }),
  (dispatch) => ({
    dispatch,
  })
)(Fechamento);



// WEBPACK FOOTER //
// ./src/componentes/Fechamento.jsx